import { Link } from "react-router-dom";
import Container from "@/components/base/Container";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <div className="border-b border-background-200/80 bg-background-100">
      <Container>
        <nav aria-label="面包屑导航" className="py-3.5">
          <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 md:text-sm">
            {items.map((item, index) => {
              const isLast = index === items.length - 1;
              return (
                <li key={item.label} className="flex items-center gap-2">
                  {item.path && !isLast ? (
                    <Link to={item.path} className="transition-colors hover:text-primary-600">
                      {item.label}
                    </Link>
                  ) : (
                    <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
                  )}
                  {!isLast ? (
                    <span className="flex h-4 w-4 items-center justify-center text-foreground-300">
                      <i className="ri-arrow-right-s-line text-base" />
                    </span>
                  ) : null}
                </li>
              );
            })}
          </ol>
        </nav>
      </Container>
    </div>
  );
}